import FqApi from '@/services/fq-api'

export default {
  async getImageThumbnail(id, size) {
    const url = `/quotes/images/thumbnail/${id}?size=${size}`
    const result = await FqApi.get(url, { responseType: 'arraybuffer' })
    const image = Buffer.from(result.data, 'binary').toString('base64')
    return `data:${result.headers['content-type'].toLowerCase()};base64,${image}`
  },
  // Full-resolution (un-resized) original image. Used by the carousel viewer so
  // clicking a thumbnail shows the stored image, not the 800px downscaled copy.
  async getImage(id) {
    const url = `/quotes/images/data/${id}`
    const result = await FqApi.get(url, { responseType: 'arraybuffer' })
    const image = Buffer.from(result.data, 'binary').toString('base64')
    return `data:${result.headers['content-type'].toLowerCase()};base64,${image}`
  }
}
